<app-header></app-header>
<div *ngIf="contactInfos">
    <form #verificationForm="ngForm" (ngSubmit)="verifyOtp()">

        <div class="flex-column d-flex justify-content-center align-items-center py-5">
            <div class="col-xs-12 col-md-9 col-lg-7 text-center">
                <app-display-picture [fileId]="getIdentityFileId()"></app-display-picture>

                <p class="text-color-finzy-blue font-largest mt-2 font-weight-bold">
                    <span appDottedLoader [appShowLoaderUntil]="user.name">{{ user.name | titlecase }}</span>
                </p>
                <div *ngIf="hasMultiplePhoneNumber(); else singlePhoneNumber">
                    <div>
                        <p class="my-4 font-normal">Looks like you have unverified phone numbers, please verify your
                            number to access your account</p>
                        <p class="my-4 font-normal">Please choose the number you want to verify. This will be used for
                            login into your account</p>
                    </div>
                    <div class="my-4">
                        <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                                 (change)="onPhoneNumberSelection($event)">

                            <mat-button-toggle value="{{contactInfo.phoneNumber}}"
                                               *ngFor="let contactInfo of contactInfos">
                                <mat-icon *ngIf="loginId === contactInfo.phoneNumber" matSuffix>check</mat-icon>
                                <span matPrefix class="input-prefix">+91</span>
                                {{contactInfo.maskedPhoneNumber}}</mat-button-toggle>
                        </mat-button-toggle-group>

                    </div>
                    <div class="my-4 font-normal">
                        <button mat-flat-button class="primary" type="button" (click)="sendOtp()"
                                [disabled]="!enableGetOtpButton()">
                            SEND OTP
                        </button>
                    </div>

                </div>
                <ng-template #singlePhoneNumber>
                    <div>
                        <p class="my-4 font-normal">Hi! please verify your number to access your account</p>
                        <p class="my-4 font-normal">The phone number associated with your account
                            is
                            <span class="text-color-finzy-blue display-inline-block"><span matPrefix
                                                                                           class="input-prefix">+91</span>
                                {{contactInfos[0].maskedPhoneNumber}}
                        </span></p>
                    </div>
                </ng-template>
            </div>
        </div>

        <div *ngIf="isOtpGenerated() || isResendEnabled()">
            <div class="row">
                <div class="col-sm-4"></div>
                <mat-form-field class="col-sm-4">
                    <input matInput placeholder="Please enter the OTP you have received" autocomplete="off"
                           [(ngModel)]="otp" name="otp" type="password" maxlength="6">
                    <button mat-stroked-button matSuffix class="btn-input-suffix" (click)="sendOtp()"
                            [disabled]="!isResendEnabled()">RESEND
                    </button>
                </mat-form-field>
                <div class="col-sm-4"></div>
            </div>
            <div class="my-4 pb-4 d-flex justify-content-center">
                <app-primary-button class="mt-5" [isLoading]="loaderStatus.isLoading">VERIFY PHONE
                    NUMBER
                </app-primary-button>
            </div>
        </div>
    </form>
    <div class="d-flex justify-content-center align-items-center py-5">
        <p class="font-normal">
        For any assistance or queries, please reach out to <span class="text-color-finzy-blue display-inline-block">support@finzy.com</span> or
        <span class="text-color-finzy-blue display-inline-block"> 9341 300 300</span>
        </p>
    </div>
</div>
